import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { transformation } from '../data/salesData';
export function TransformSection() {
  return <section className="bg-[var(--bg-deep)] py-16 sm:py-20" data-id="element-246" data-mp="2z6ww9r64sf9o">
      <div className="mx-auto max-w-5xl px-4" data-id="element-247" data-mp="2lf09m2n8exko">
        <h2 className="mx-auto max-w-3xl text-center font-serif-display text-3xl font-bold leading-tight text-[var(--text)] sm:text-4xl" data-id="element-248" data-mp="2lc4boebdw8w8">
          El próximo alumno limitado que llega puede cambiar tu año
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-249" data-mp="3i4ho9746ztyi">
          <figure className="flex h-full flex-col rounded-2xl border border-[var(--line)] bg-white/[0.03] p-6" data-id="element-250" data-mp="3i3y55n2t2ziw">
            <figcaption className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--text-soft)]" data-id="element-251" data-mp="346t1ftqkecqt">
              Antes · sin sistema
            </figcaption>
            <blockquote className="mt-4 text-[var(--text)]/75" data-id="element-252" data-mp="1sory2tn7bbf2">
              {transformation.before}
            </blockquote>
          </figure>

          <figure className="flex h-full flex-col rounded-2xl border border-[var(--rose)]/40 bg-[var(--rose-tint)] p-6" data-id="element-253" data-mp="1do7r4gq7ry5n">
            <figcaption className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--rose)]" data-id="element-254" data-mp="19n4b9u86224f">
              Después · con Pilates Clinic
            </figcaption>
            <blockquote className="mt-4 text-[var(--text)]" data-id="element-255" data-mp="1nk12vxw3znmd">
              {transformation.after}
            </blockquote>
          </figure>
        </div>

        <ol className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-3" data-id="element-256" data-mp="1wlr2vs423uvr">
          {transformation.cycle.map((step, i) => <li key={step} className="flex items-center gap-3" data-id="element-257" data-mp="1sjnmqq6g0245" data-mpi={i}>
              <span className="rounded-full border border-[var(--line)] bg-[var(--surface)] px-4 py-2 text-sm text-[var(--text)]/85" data-id="element-258" data-mp="26cde7a4qpz8n">
                {step}
              </span>
              {i < transformation.cycle.length - 1 && <ArrowRightIcon className="hidden h-4 w-4 text-[var(--rose)] sm:block" aria-hidden="true" data-id="element-259" data-mp="2bbycdic363kb" />}
            </li>)}
        </ol>

        <p className="mt-8 text-center font-serif-display text-2xl italic text-[var(--rose)]" data-id="element-260" data-mp="2ndzklszmr8ma">
          Ese es el ciclo.
        </p>
      </div>
    </section>;
}